import { useState, useEffect } from 'react';

const calculateZoomLevel = () => {
  const ratio = window.devicePixelRatio || 1;
  const visualViewport = window.visualViewport;
  if (visualViewport && Number.isFinite(visualViewport.scale)) {
    return Math.min(visualViewport.scale, 1.5);
  }
  return Math.min(ratio, 1.5);
};

const getViewportState = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const pixelRatio = window.devicePixelRatio || 1;
  const zoomLevel = calculateZoomLevel();
  return {
    width,
    height,
    pixelRatio,
    zoomLevel,
    isSmallMobile: width < 480,
    isMobile: width < 768,
    isTablet: width >= 768 && width < 1024,
    isDesktop: width >= 1024,
    isLargeDesktop: width >= 1440,
    orientation: width > height ? 'landscape' : 'portrait'
  };
};

export const useViewport = () => {
  const [viewport, setViewport] = useState({
    ...(typeof window !== 'undefined'
      ? getViewportState()
      : {
          width: 1200,
          height: 800,
          isMobile: false,
          isTablet: false,
          isDesktop: true,
          isSmallMobile: false,
          isLargeDesktop: false,
          orientation: 'landscape',
          zoomLevel: 1,
          pixelRatio: 1
        })
  });

  useEffect(() => {
    const handleResize = () => {
      const nextViewport = getViewportState();
      setViewport(nextViewport);
      const root = document.documentElement;
      root.style.setProperty('--viewport-width', `${nextViewport.width}px`);
      root.style.setProperty('--viewport-zoom', nextViewport.zoomLevel);
    };

    // Ejecutar inmediatamente al cargar
    handleResize();

    // Listeners para todos los eventos de redimensionamiento
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleResize);
    }

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  return viewport;
};